export const HUB_MODES = {
  TEACHER_HUB: 'hub',
  TEACHER_FOLDER_TO_EVAL: 'to_eval',
  TEACHER_FOLDER_TO_DO: 'to_do',
  TEACHER_IN_PERSON: 'in_person'
};
